<template>
  <BaseModal
    :title="
      ultimateLearningOutcome
        ? 'Edit an ultimate learning outcome'
        : 'Create an ultimate learning outcome'
    "
    hide-footer
    size="xl"
    :show.sync="$show"
  >
    <form-learning-outcome
      :id="ultimateLearningOutcomeId"
      :learning-unit-id="learningUnitId"
      :form-data="ultimateLearningOutcome"
      :api-provider="ultimateLearningOutcomeProvider"
      :redirect="false"
      class="form__ultimate-lo"
      @back="onCancelUltimateLo"
      @submit="onSubmitUltimateLo"
    />
  </BaseModal>
</template>

<script>
import LearningOutcome from '@/models/LearningOutcome';
import BaseModal from '@/components/base-components/BaseModal';
import FormLearningOutcome from '@/components/LearningOutcome/FormLearningOutcome';

export default {
  components: {
    BaseModal,
    FormLearningOutcome
  },

  props: {
    learningUnitId: {
      type: [String, Number],
      required: true
    },

    ultimateLearningOutcome: {
      type: LearningOutcome,
      default: null
    },

    show: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    $show: {
      get() {
        return this.show;
      },

      set(v) {
        this.$emit('update:show', v);
      }
    },

    ultimateLearningOutcomeId() {
      return this.ultimateLearningOutcome ? this.ultimateLearningOutcome.id : null;
    }
  },

  methods: {
    async ultimateLearningOutcomeProvider(data) {
      let promise;

      if (this.ultimateLearningOutcome) {
        promise = await LearningOutcome.api().updateUltimateLearningOutcome(
          this.ultimateLearningOutcome.id,
          data
        );
      } else {
        promise = await LearningOutcome.api().createUltimateLearningOutcome(
          this.learningUnitId,
          data
        );
      }

      return promise;
    },

    onCancelUltimateLo() {
      console.log('onCancelUltimateLo');
      this.$show = false;
    },

    onSubmitUltimateLo() {
      this.$show = false;
    }
  }
};
</script>
